import { useContext } from "react";

import { EnterpriseContext } from "@/context/EnterpriseContext";
import { UserContext } from "@/context/UserContext";

export const useConsentGatedAnalytics = () => {
  const { user } = useContext(UserContext);
  const enterpriseContext = useContext(EnterpriseContext);
  const gdprEnabled = enterpriseContext?.featureToggles?.gdprEnabled;

  if (!gdprEnabled) {
    return { analyticsAllowed: true, experienceAllowed: true };
  }

  return {
    analyticsAllowed: !!user?.states?.gdprConsentAnalytics,
    experienceAllowed: !!user?.states?.gdprConsentExperience,
  };
};
